import ApplicationSettingsNavigation from './ApplicationSettingsNavigation';

export default ApplicationSettingsNavigation;
